import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useMountEffect } from 'js/hooks/useMountEffect';
import { usePortletConfig, usePortletDispatch } from 'js/components/system/Portlet';

import { getRecentlyPlayed, setRecentlyPlayedAction, updateRecentlyPlayedIsLoading } from './actions';

export const useRecentlyPlayed = () => {
    const { includeRecentlyPlayed } = usePortletConfig();
    const isLoggedIn = useUserSelector(prop(['isLoggedIn']));
    const dispatch = usePortletDispatch();

    useMountEffect((isMounted) => {
        if (!includeRecentlyPlayed || !isLoggedIn) {
            return;
        }

        dispatch(updateRecentlyPlayedIsLoading(true));

        getRecentlyPlayed()
            .then((response = {}) => {
                if (isMounted()) {
                    const { data: { tags = [] } = {} } = response;
                    const { value: gameCodes } = tags.find(tag => tag.name === 'uam/hidden/playerRecentGames') || {};
                    const parsedGameCodes = typeof gameCodes === 'string'
                        ? JSON.parse(gameCodes)
                        : gameCodes;

                    dispatch(setRecentlyPlayedAction(parsedGameCodes));
                }
            })
            .catch(console.error)
            .finally(() => isMounted() && dispatch(updateRecentlyPlayedIsLoading(false)));
    }, [isLoggedIn, includeRecentlyPlayed, dispatch]);
};
